import request from '@/utils/ajax'


export function saveMt4Config(data) {
    return request({
        url: '/wx/manage/mt4Notifier/save',
        method: 'post',
        data: data
    })
}

export function editMt4Config(data) {
    return request({
        url: '/wx/manage/mt4Notifier/update',
        method: 'put',
        data: data
    })
}

export function deleteMt4ChanelConfig(data) {
    return request({
        url: '/wx/manage/mt4Notifier/delete',
        method: 'post',
        data: data
    })
}
